import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import {
  updateAutoSettlementFlag,
} from '../../Actions/actions';

class AddVehicleInModalSuccess extends React.Component {
  componentWillUnmount() {
    const { vehicleFrom2 } = this.props;
    const userId = localStorage.getItem('userId');
    if (vehicleFrom2 === true) {
      this.props.updateAutoSettlementFlag({
        userId,
        autoSettlementFlag: 'N',
      });
    }
  }

  render() {
    return (
      <span>
        <p>
          {' '}
          Your vehicles have been added. To view the settlements we have matched you to,
          {' '}
          <Link to="/enrollment">click here</Link>
          {' '}
        </p>
        <p>
        If you need to make changes or add more vehicles, go to
          {' '}
          My Profile
          {' '}
          and edit My Vehicles.
        </p>
      </span>

    );
  }
}

AddVehicleInModalSuccess.contextTypes = {
  router: PropTypes.object.isRequired,
};


const mapStateToProps = state => ({
  data: state.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateAutoSettlementFlag,
  }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(AddVehicleInModalSuccess));
